import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  href?: string;
}
const getUtmParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = ['source', 'medium', 'campaign', 'content'].map(param => {
    const value = urlParams.get(`utm_${param}`);
    return value ? `utm_${param}=${value}` : null;
  }).filter(Boolean).join('&');
  return utmParams ? `?${utmParams}` : '';
};
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  onClick,
  href,
  ...props
}) => {
  const location = useLocation();
  const isDealflowPath = location.pathname === '/deals';
  const [isTypeformReady, setIsTypeformReady] = useState(false);
  useEffect(() => {
    const checkTypeform = () => {
      if (window.typeform) {
        setIsTypeformReady(true);
      }
    };
    // Check immediately if Typeform is already loaded
    checkTypeform();
    // Set up observer for Typeform loading
    const observer = new MutationObserver(checkTypeform);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  const baseStyles = 'font-medium rounded-md transition-all duration-200 inline-flex items-center justify-center animate-shake';
  const variantStyles = {
    primary: 'bg-[#00c853] text-white hover:bg-[#00a844] shadow-lg shadow-[#00c853]/20',
    secondary: 'bg-dark-600 text-[#00c853] border border-[#00c853] hover:bg-dark-500',
    outline: 'bg-transparent text-[#00c853] border border-[#00c853] hover:bg-[#00c853]/10'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const utmParams = getUtmParams();
    if (isDealflowPath && isTypeformReady) {
      try {
        window.typeform.open('01JWW19D8PHS1WZ3T8E9DVTSBH', {
          mode: 'popup',
          hideHeaders: true,
          hideFooter: true,
          opacity: 75,
          autoClose: 3000,
          onSubmit: () => {
            window.location.href = '/deals/thankyou';
          }
        });
      } catch (error) {
        console.error('Failed to open Typeform:', error);
        // Fallback to direct link if Typeform fails
        const targetUrl = href ? `${href}${utmParams}` : `https://form.typeform.com/to/01JWW19D8PHS1WZ3T8E9DVTSBH${utmParams}`;
        window.location.href = targetUrl;
      }
    } else if (href) {
      window.location.href = `${href}${utmParams}`;
    }
    if (onClick) {
      onClick();
    }
  };
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`} onClick={handleClick} {...props} data-id="element-710">
      {children}
    </button>;
};